<div class="editor">
	<input
		#input
		type="number"
		class="editor__input"
		step="0.0001"
		focusInitial
		[(ngModel)]="value"
		[selectAll]="highlightAllOnFocus"
		[withDelay]="true"
		[min]="min"
		[max]="max"
		(keydown)="onKeyDown($event)" />
</div>
